import { http } from "@/http";

export default {
  list(data, params) {
    return http.post("/celulares/payment-made-batches/list", data, { params });
  },
  uploadBatch(data) {
    return http.post("/celulares/payment-made-batches", data);
  },
  downloadTemplate() {
    return http.get('/celulares/payment-made-batches/template/xlsx', {responseType: 'blob'})
  }
};
